import React, { useEffect } from "react";
import { useAppContext } from "../context";
import backgroundMusic from '/sounds/bg.mp3';

const backgroundAudio = new Audio(backgroundMusic);
backgroundAudio.loop = true;

export const SoundProvider = (props: { children: React.ReactNode }) => {
    const { musicPlay } = useAppContext();

    useEffect(() => {
        if (musicPlay) {
            if (backgroundAudio.paused) {
                backgroundAudio.play();
            }
        } else {
            backgroundAudio.pause();
        }

    }, [musicPlay]);

    return props.children;
}